 (function () {
    const cartFetch = window.__nativeFetch || window.fetch

    function getCart() {
      return document.querySelector('cart-notification') || document.querySelector('cart-drawer')
    }

    function getActiveCodes() {
      return Array.from(document.querySelectorAll('.cart-discount__pill')).map((pill) => pill.dataset.discountCode)
    }

    function updateDiscounts(codes) {
      const cart = getCart()
      if (!cart) return Promise.reject(new Error('cart not found'))

      const body = {
        discount: codes.join(','),
        sections: cart.getSectionsToRender().map((section) => section.id),
        sections_url: window.location.pathname + (window.location.search || '?'),
      }

      return cartFetch(window.routes.cart_update_url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify(body),
      }).then((response) => response.json())
    }

    function applyNewCode(newCode, triggerButton, errorEl) {
      const activeCodes = getActiveCodes()
      if (!newCode || activeCodes.includes(newCode)) return

      if (errorEl) {
        errorEl.hidden = true
        errorEl.textContent = ''
      }
      if (triggerButton) triggerButton.setAttribute('aria-disabled', 'true')

      updateDiscounts(activeCodes.concat([newCode]))
        .then((data) => {
          const cart = getCart()
          const failed = data.discount_codes && data.discount_codes.find((d) => d.code === newCode && !d.applicable)

          if (cart) cart.renderContents(data)

          if (failed && errorEl) {
            errorEl.hidden = false
            errorEl.textContent = 'Código no válido o no aplicable a este carrito.'
          }
        })
        .catch((e) => console.error(e))
        .finally(() => {
          if (triggerButton) triggerButton.removeAttribute('aria-disabled')
        })
    }

    document.addEventListener('submit', function (event) {
      const form = event.target.closest('#CartDiscountForm')
      if (!form) return
      event.preventDefault()

      const input = form.querySelector('#CartDiscountInput')
      const errorEl = document.getElementById('CartDiscountError')
      const submitButton = form.querySelector('button[type="submit"]')
      const newCode = input.value.trim()

      applyNewCode(newCode, submitButton, errorEl)
    })

    document.addEventListener('click', function (event) {
      const promoButton = event.target.closest('.cart-promo-discount__button')
      if (promoButton) {
        event.preventDefault()
        applyNewCode(promoButton.dataset.promoCode, promoButton, null)
        return
      }

      const removeButton = event.target.closest('.cart-discount__pill-remove')
      if (removeButton) {
        event.preventDefault()

        const pill = removeButton.closest('.cart-discount__pill')
        const codeToRemove = pill.dataset.discountCode
        const remainingCodes = getActiveCodes().filter((code) => code !== codeToRemove)

        updateDiscounts(remainingCodes)
          .then((data) => {
            const cart = getCart()
            if (cart) cart.renderContents(data)
          })
          .catch((e) => console.error(e))
      }
    })
  })();
